// extracted by mini-css-extract-plugin
export default {"root":"y3qQq59l","url":"rRDBYOU3"};